import React from 'react';
import { Link } from 'react-router-dom';
import { findHashtags } from '../utils/hashtags';
import './hashtags.css';

export default function PostText({ content = '', onTagClick }) {
  const parts = [];
  let cursor = 0;
  for (const match of findHashtags(content)) {
    parts.push(content.slice(cursor, match.start));
    parts.push(<Link key={match.start} className="jt-hashtag" data-control="text" data-control-id="PostText-hashtag" to={`/?tag=${encodeURIComponent(match.tag)}`} onClick={event => { event.stopPropagation(); onTagClick?.(); }}>{match.label}</Link>);
    cursor = match.end;
  }
  parts.push(content.slice(cursor));
  return <>{parts}</>;
}
